import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FamilyCasesService, FamilyCase } from '../family-cases/family-cases.service';

@Component({
	selector: 'app-case-search',
	standalone: true,
	imports: [CommonModule, FormsModule],
	templateUrl: './case-search.component.html'
})
export class CaseSearchComponent implements OnInit {
	q = '';
	fromDate?: string;
	toDate?: string;
	results: FamilyCase[] = [];
	selected?: FamilyCase;
	imageUrl?: string;

	constructor(private api: FamilyCasesService) {}
	ngOnInit(): void { }

	search() {
		// use list and client filter for simplicity; could be server query params
		this.api.list().subscribe(data => {
			this.results = data.filter(e => {
				const match = !this.q || (e.headNationalId?.includes(this.q) || e.memberNationalId?.includes(this.q) || e.registryNumber?.includes(this.q));
				if (!match) return false;
				let ok = true;
				const start = this.fromDate ? new Date(this.fromDate) : null;
				const end = this.toDate ? new Date(this.toDate) : null;
				if (start || end) {
					const d = e.caseDate ? new Date(e.caseDate) : null;
					if (!d) return false;
					if (start && d < new Date(start.toDateString())) ok = false;
					if (end) {
						const eod = new Date(end.toDateString()); eod.setHours(23,59,59,999);
						if (d > eod) ok = false;
					}
				}
				return ok;
			});
		});
	}

	viewImage(item: FamilyCase) {
		if (!item.id) return;
		this.selected = item;
		this.api.getImageBlob(item.id).subscribe(blob => {
			if (blob && blob.size > 0) {
				this.imageUrl = URL.createObjectURL(blob);
			} else {
				this.imageUrl = undefined;
			}
		});
	}
}


